import React, { useEffect, useState } from "react";
import Typed from "react-typed";

const AboutAccessibility = () => {
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(
      "https://new.whatson.agency/wp-json/wp/v2/posts?categories=80&_fields=id,title,content"
    )
      .then((res) => res.json())
      .then((data) => {
        if (data && data.length > 0) {
          setPost(data[0]); // Take first post from category 80
        }
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching Accessibility content:", err);
        setLoading(false);
      });
  }, []);

  return (
    <div className="rwt-about-area rn-section-gap">
      <div className="container">
        <div className="row row--30 align-items-center">
          {/* Optional image section */}
          {/* <div className="col-lg-5">
            <div className="thumbnail">
              <img
                className="w-100"
                src="./images/about/about-1.png"
                alt="About Images"
              />
            </div>
          </div> */}

          <div className="col-lg-10 mt_md--40 mt_sm--40">
            <div className="content">
              <div className="section-title">
                {/* Title with Typed animation */}
                <h2 className="title">
                  Accessibility Statement <br />{" "}
                  <Typed
                    className="theme-gradient"
                    strings={["Accessibility", "Data Security", "Your Rights"]}
                    typeSpeed={80}
                    backSpeed={5}
                    backDelay={1000}
                    loop
                  />
                </h2>

                {/* Loading state */}
                {loading && <p>Loading...</p>}

                {/* Post title from WP */}
                {!loading && post && (
                  <h3
                    className="accessibility-title"
                    dangerouslySetInnerHTML={{ __html: post.title.rendered }}
                  />
                )}

                {/* Post content from WP */}
                {!loading && post && (
                  <div
                    className="accessibility-content"
                    dangerouslySetInnerHTML={{
                      __html: post.content.rendered,
                    }}
                  />
                )}

                {/* No post found */}
                {!loading && !post && (
                  <p>No Accessibility content found.</p>
                )}

                {/* Contact button */}
                <div className="read-more-btn mt--40">
                  <a className="btn-default" href="/contact">
                    <span>Contact With Us</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutAccessibility;
